import { relativeToAbsoluteURL, URLObject } from '../links';

export interface MetaAttributes {
  title: string,
  description: string,
  urlObject: URLObject,
}

export interface PageableOptions {
  page: number,
  first: boolean,
  last: boolean,
  hasResults: boolean,
}

export const DEFAULT_PAGEABLE = {
  page: 1,
  first: true,
  last: false,
  hasResults: true,
};

export function buildPageableSEO({ title, description, urlObject: relativeURL }: MetaAttributes, pageable: PageableOptions = DEFAULT_PAGEABLE) {
  const pageableSEO: any = {
    title: pageable.first ? title : `${title} | Pagina ${pageable.page}`,
    description: pageable.first ? description : `${description}. Pagina ${pageable.page}`,
    canonical: relativeToAbsoluteURL(relativeURL.as, pageable.page > 1 ? { p: pageable.page } : undefined),
    robots: pageable.page === 1 && !pageable.hasResults ? ['noindex'] : [],
  };

  if (!pageable.last && pageable.hasResults) {
    pageableSEO.next = relativeToAbsoluteURL(relativeURL.as, { p: pageable.page + 1 });
  }

  if (!pageable.first && pageable.hasResults) {
    pageableSEO.prev = relativeToAbsoluteURL(relativeURL.as, {
      p: pageable.page === 2 ? undefined : pageable.page - 1,
    });
  }

  return pageableSEO;
}
